import {
  Modal,
  Form,
  Input,
  Select,
  Upload,
  DatePicker,
  Row,
  Col,
  Button,
} from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Country from "../../utils/country.json";
import dayjs from "dayjs";
import { updateUserFormsDetails } from "../../services/awsServices";
import toastMessage from "../../utils/toastMessage";
import { uploadDocFun } from "../../utils/utils";
import { getUserAllFormsDetails } from "../../slices/userSlice";
import { UploadOutlined } from "@ant-design/icons";

const AddInternationalAchievementModal = ({
  isModalOpen,
  setIsModalOpen,
  title,
  gold,
  silver,
  bronze,
}) => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [userData, setUserData] = useState({});
  const [uploadDoc, setUploadDoc] = useState();
  const dispatch = useDispatch();
  const handleOk = () => {
    setIsModalOpen(false);
  };

  title = title.props.children[0].props.children
  console.log({title})
  const [selectedCountry, setSelectedCountry] = useState(null);

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
  };

  // console.log(gold[0]?.Data, " ===gollddddddddd");
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const onSave = async (values) => {
    console.log(values, "valuessssssssss")
    setLoader(true);
    const formattedDate = values.Date
      ? dayjs(values.Date).format(import.meta.env.VITE_APP_DATE_FORMAT)
      : undefined;
    var apiPayload = {};

    if (title === "International Achievements" && values.SK === "Gold") {
      apiPayload = {
        SK: "Achievements#International#Gold",
        Data:
          gold[0]?.Data.length > 0
            ? [
                ...gold[0].Data,
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ]
            : [
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ],
      };
    }
    if (title === "International Achievements" && values.SK === "Silver") {
      apiPayload = {
        SK: "Achievements#International#Silver",
        Data:
          silver[0]?.Data.length > 0
            ? [
                ...silver[0].Data,
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ]
            : [
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ],
      };
    }
    if (title === "International Achievements" && values.SK === "Bronze") {
      apiPayload = {
        SK: "Achievements#International#Bronze",
        Data:
          bronze[0]?.Data.length > 0
            ? [
                ...bronze[0].Data,
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ]
            : [
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ],
      };
    }
    if (title === "National Achievements" && values.SK === "Bronze") {
      apiPayload = {
        SK: "Achievements#National#Bronze",
        Data:
          bronze[0]?.Data.length > 0
            ? [
                ...bronze[0].Data,
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ]
            : [
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ],
      };
    }
    if (title === "National Achievements" && values.SK === "Silver") {
      apiPayload = {
        SK: "Achievements#National#Silver",
        Data:
          silver[0]?.Data.length > 0
            ? [
                ...silver[0].Data,
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ]
            : [
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ],
      };
    }
    if (title === "National Achievements" && values.SK === "Gold") {
      apiPayload = {
        SK: "Achievements#National#Gold",
        Data:
          gold[0]?.Data.length > 0
            ? [
                ...gold[0].Data,
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ]
            : [
                {
                  ...values,
                  Date: formattedDate,
                  Attachments: uploadDoc,
                },
              ],
      };
    }
    console.log({apiPayload})

    try {
      const response = await updateUserFormsDetails(apiPayload);

      toastMessage(
        response.data?.message || "Your Achievement has been Added",
        "success"
      );
    } catch (error) {
      toastMessage("Something went wrong", "error");
    } finally {
      setLoader(false);
      setIsModalOpen(false);
      form.resetFields();
      dispatch(getUserAllFormsDetails()).unwrap();
    }
  };

  const props = {
    headers: {
      authorization: "authorization-text",
    },
    accept: "image/png, image/jpeg, image/jpg, .pdf, .doc",
    beforeUpload: () => false,
    maxCount: 1,
    onChange: async () => {
      setLoader(true);
      const res = await uploadDocFun(form.getFieldValue("Attachments"));
      if (res) {
        setUploadDoc(res);
      }
      setLoader(false);
    },
  };

  return (
    <>
      <Modal
        width={"50%"}
        // closeIcon={false}
        footer={false}
        title={
          <h1 className="bg-tabsTextStyle inline-block text-transparent bg-clip-text text-2xl font-semibold">
            {title}
          </h1>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          requiredMark={false}
          form={form}
          onFinish={onSave}
          layout="vertical"
          onChange={(e) => console.log(e.target.value)}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Name Of Award"
                name="Name"
                rules={[
                  {
                    validateTrigger: false,
                    required: true,
                    message: "Please input the achievement name!",
                  },
                ]}
              >
                <Input placeholder="Achievement Name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Type Of Recognition"
                name="SK"
                rules={[
                  {
                    required: true,
                    message: "Please select an achievement type!",
                  },
                ]}
              >
                <Select
                className=""
                  // mode="tags" // or mode="multiple" if you want multiple selections
                  placeholder="Select Achievement Type"
                >
                  <Select.Option key="Gold">Gold</Select.Option>
                  <Select.Option key="Silver">Silver</Select.Option>
                  <Select.Option key="Bronze">Bronze</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item
                label="Country"
                name="Country"
                rules={[
                  { required: true, message: "Please select a location!" },
                ]}
              >
                <Select
                  placeholder="Saudi Arabia"
                  onChange={handleCountryChange}
                  allowClear
                  showSearch
                >
                  {Country.map((item) => (
                    <Select.Option key={item.label} value={item.label}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="City"
                name="City"
                rules={[{ required: true, message: "Please select a City!" }]}
              >
                <Select
                  placeholder="Riyadh"
                  disabled={!selectedCountry}
                  allowClear
                  showSearch
                >
                  {selectedCountry &&
                    Country.find(
                      (item) => item.label === selectedCountry
                    )?.cities.map((city) => (
                      <Select.Option key={city}>{city}</Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                label="Evidence of Award"
                name="Attachments"
                rules={[
                  {
                    required: true,
                    message: "Please upload an attached document!",
                  },
                ]}
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) {
                    return e;
                  }
                  return e && e.fileList;
                }}
              >
                <Upload {...props}>
                  <Button className="w-full" icon={<UploadOutlined />}>
                    Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Date Received"
                name="Date"
                rules={[{ required: true, message: "Please select a date!" }]}
              >
                <DatePicker
                  disabledDate={(current) => {
                    return current && current > dayjs().startOf("day");
                  }}
                  placeholder="Select Date"
                  className="w-full"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Description"
                name="Rank"
                rules={[
                  {
                    required: true,
                    message:
                      "Description Length should be minimum 10 characters",
                    min: 10,
                  },
                ]}
              >
                <Input placeholder="Description" />
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item
                label="Contact of Organization"
                name="ContactOfOrganization"
                rules={[
                  {
                    required: true,
                    message: "Please input the Contact of Organization!",
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder="Contact of Organization"
                  className="[&::-webkit-inner-spin-button]:appearance-none"
                />
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                label="Name & Location of Awarding Entity"
                name="Name & Location of Awarding Entity"
                rules={[
                  {
                    required: true,
                    message:
                      "Please input the Name & Location of Awarding Entity!",
                  },
                ]}
              >
                <Input placeholder="e.g. International Science and Engineering Fair, USA" />
              </Form.Item>
            </Col>
            <Col span={24} className="flex justify-center items-center">
              <Form.Item>
                <Button
                  loading={loader}
                  htmlType="submit"
                  className="bg-tabsTextStyle rounded-3xl text-pureWhite p-2 px-5 text-lg flex justify-center items-center"
                >
                  Save Changes
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddInternationalAchievementModal;
